import React from 'react';

import { createBridgeLayerRender } from '../../shared/utils/create-bridge-layer-render';
import { GarageLayerData } from '../../domains/vehicle-management/components/GarageLayerContent/hooks/useGarageLayerData';
import { GarageLayerContentView } from '../../domains/vehicle-management/components/GarageLayerContent/GarageLayerContentView';
import { ManageDealerLayerContentView, ManageDealerLayerViewProps } from '../../domains/manage-dealer/components/ManageDealerLayerContent/ManageDealerLayerContentView';
import { useGarageLayer } from '../../domains/vehicle-management/layer-manager/hooks/useGarageLayer';
import { useDealerLayer } from '../../domains/manage-dealer/layer-manager/hooks/useDealerLayer';

interface AppLayersProps {
  garageActive: boolean;
  onGarageClose: () => void;
  dealerLayerActive: boolean;
  onDealerLayerClose: () => void;
}

const garageLayerRender = createBridgeLayerRender<GarageLayerData>(
  (data) => data.translationHandler('garage.layer.title'),
  (data) => (
    <GarageLayerContentView
      vehicles={data.vehicles}
      preferredVehicle={data.preferredVehicle}
      translationHandler={data.translationHandler}
      trackingManager={data.trackingManager}
      onVehicleAction={data.onVehicleAction}
      onAddVehicle={data.onAddVehicle}
      onNavigateToVehicleManagement={data.onNavigateToVehicleManagement}
    />
  ),
);

const dealerLayerRender = createBridgeLayerRender<ManageDealerLayerViewProps>(
  (data) => data.translationHandler(data.titleKey),
  (data) => <ManageDealerLayerContentView {...data} />,
);

export const useAppLayers = ({
  garageActive,
  onGarageClose,
  dealerLayerActive,
  onDealerLayerClose,
}: AppLayersProps) => {
  useGarageLayer(garageActive, onGarageClose, garageLayerRender);
  useDealerLayer(dealerLayerActive, onDealerLayerClose, dealerLayerRender);
};
